import { lazy } from 'react';

export const CatalogPageAsync = lazy(() => import('./CatalogPage'));
